export default __webpack_public_path__ + "static/cc-icon-954bbc1d80139021191b94a3bae60ec2.png";